// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2ndgJ","inputWrap":"CustomTip_inputWrap__2Lp3Z"};